import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as cls from "./modalNotifications.module.scss";
import {
  lssBlockNotificationDataAction,
  notificationsSummariesAction,
  showNotificationDetailAction,
} from "../../redux/actions/actions";
import ModalAttestationTheme from "../modalAttestationTheme/ModalAttestationTheme";
import { StudentService } from "../studentService";
import { useNavigate } from "react-router-dom";
import ModalMessage from "../modalMessage/ModalMessage";
import ModalCaptcha from "../modalCaptcha/ModalCaptcha";
import Anket from "../modalAnket/Anket";
import LinearLoader from "../linearLoader/LinearLoader";
import { Button } from "../../../personal-studio-components/form";
import { CircularProgress } from "@mui/material";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
export default function ModalNotifications({ setNotifiactionsData }) {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(showNotificationDetailAction(false));
  };

  const { currentNotificationData } = useSelector(
    (state) => state.notifications,
  );

  const [data, setData] = useState(null);
  const [firstdata, setFirstData] = useState(null);
  const [inputValue, setInputValue] = useState(
    currentNotificationData?.is_event_actual,
  );
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const { open } = useSelector((state) => state.notifications);
  const [isAprooveBtnActive, setIsAprooveBtnActive] = useState(false);
  const [captchaUrl, setCaptchaUrl] = useState("");
  const [captchaData, setCaptchaData] = useState("");
  const [captchaUuid, setCaptchaUuid] = useState("");
  const [hasCaptcha, setHasCaptcha] = useState(false);
  const [isShowControlBtn, setIsShowControlBtn] = useState(true);
  const [modalMessage, setModalMessage] = useState("");
  const [modalMessageOpen, setModalMessageOpen] = useState(false);
  const [openCaptchaModal, setOpenCaptchaModal] = useState(false);
  const [comment, setComment] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isRenderWithComponent, setIsRenderWithComponent] = useState(false);
  const [isElectronicAccept, setIsElectronicAccept] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [commentFromDB, setCommentFromDB] = useState("");
  const [modalMessageTitle, setModalMessageTitle] = useState("");
  const [isLoadingBtn, setIsLoadingBtn] = useState(null);

  const navigate = useNavigate();
  async function getDetail() {
    const request = {
      method: "post",
      path: "/student/notification/get",
      data: {
        access_token,
        study_contract_id: contractId,
        planning_event_id: currentNotificationData.planning_event_id,
      },
    };
    const data = await StudentService.send(request, (response) => {});
    if (!data.errors) {
      if (
        data.is_electronic_accept &&
        data.agreement_text !== null &&
        data.is_event_actual
      ) {
        setData({ ...data, is_event_actual: true, LSSBlocking: false });
        setIsElectronicAccept(true);
        return;
      } else {
        setIsElectronicAccept(false);
      }
      if (
        data.text &&
        (data.text.includes("Notificationchoice") || data.DisableManualAccept)
      ) {
        setIsShowControlBtn(false);
      } else {
        setIsShowControlBtn(true);
      }

      setCaptchaUrl(data.captcha_url);
      setCaptchaUuid(data.captcha_uuid);

      if (data.captcha_url && data.captcha_uuid) {
        setData({ ...data, text: data.text });
        setHasCaptcha(true);
        return;
      }

      if (
        data.text &&
        data.text.match(/@QUESTIONS@\d{1,}@/gm) &&
        !data.text.match(/onclick/gm)
      ) {
        const renderTextWithAnketComponents = (text, anketa_id) => {
          const parts = text.split(`@QUESTIONS@${anketa_id}@`);

          return parts.map((part, index) => {
            return (
              <div>
                <p dangerouslySetInnerHTML={{ __html: part }}></p>
                {index < parts.length - 1 && (
                  <Anket
                    handleAgreement={handleAgreementAfterAnket}
                    anketa_id={anketa_id}
                    getDetail={getDetail}
                    planning_event_id={
                      currentNotificationData.planning_event_id
                    }
                  />
                )}
              </div>
            );
          });
        };
        const index = data.text.lastIndexOf("@");
        const anketa_id = data.text[index - 1];
        const transformedText = renderTextWithAnketComponents(
          data.text,
          anketa_id,
        );
        setData((prev) => {
          return { ...data, text: transformedText };
        });
        setIsRenderWithComponent(true);
        return;
      }

      setFirstData(data);

      setData(data);
    }
  }
  async function handleAgreement({ event, comment, args }) {
    if (hasCaptcha) {
      setOpenCaptchaModal(true);
      return;
    }
    if (currentNotificationData?.planning_event_id) {
      const data = {
        access_token,
        study_contract_id: contractId,
        planning_event_id: currentNotificationData?.planning_event_id,
        message: event,
        comment,
      };
      if (!event || typeof event === "object") {
        delete data.event;
      }
      const request = {
        method: "post",
        path: "/student/portfolio/notification_choice",
        data: data,
      };
      setIsLoading(true);
      const response = await StudentService.send(request, (response) => {}); //
      if (!response.errors) {
        if (data.EventTypeID === 18440) {
          getDetail();
        }
        if (args && args[1]) {
          window.location.href = args[1];
        }
        if (event !== "Event18800_v1") {
          handleClose();
        }
      }

      if (response.errors) {
        if (
          response.errors[0] ===
          "Ошибка: Вы не прошли проверку капчи, попробуйте снова."
        ) {
          getDetail();
        }
        const err = response;
        const errorEvent = new ErrorEvent("error", {
          error: err,
        });
        window.dispatchEvent(errorEvent);
      }
      setIsLoadingBtn(null);

      setIsLoading(false);
    }
  }
  async function handleAgreementAfterAnket(message = "", comment = "") {
    if (hasCaptcha) {
      setOpenCaptchaModal(true);
      return;
    }
    if (currentNotificationData?.planning_event_id) {
      const data = {
        access_token,
        study_contract_id: contractId,
        planning_event_id: currentNotificationData?.planning_event_id,
        message,
        comment,
      };
      if (!message || typeof message === "object") {
        delete data.message;
      }
      const request = {
        method: "post",
        path: "/student/portfolio/notification_choice",
        data: data,
      };
      const response = await StudentService.send(request, (response) => {});
      if (!response.errors) {
        setIsLoadingBtn(null);

        return response;
      }

      if (response.errors) {
        setIsLoadingBtn(null);

        if (
          response.errors[0] ===
          "Ошибка: Вы не прошли проверку капчи, попробуйте снова."
        ) {
          getDetail();
        }
        const err = response;
        const errorEvent = new ErrorEvent("error", {
          error: err,
        });
        window.dispatchEvent(errorEvent);
        return response;
      }
    }
  }
  async function handleAgreementWithCaptcha(message = "", comment = "") {
    if (currentNotificationData?.planning_event_id) {
      const requestData = {
        access_token,
        study_contract_id: contractId,
        planning_event_id: currentNotificationData?.planning_event_id,
        message,
        captcha_data: captchaData,
        captcha_uuid: captchaUuid,
        comment,
      };
      if (!message || typeof message === "object") {
        delete data.message;
      }
      const request = {
        method: "post",
        path: "/student/portfolio/notification_choice",
        data: requestData,
      };
      setIsLoading(true);
      const response = await StudentService.send(request, (response) => {});

      if (!response.errors) {
        if (data.EventTypeID === 18680) {
          navigate("/learning-plan");
        }
        if (data.EventTypeID === 18440) {
          setData(null);
          await getDetail();
          setOpenCaptchaModal(false);
        } else handleClose();
        // dispatch(currentNotificationIndexAction());
      }

      if (response.errors && response.error_type !== "auth") {
        if (
          response.errors[0] ===
          "Ошибка: Вы не прошли проверку капчи, попробуйте снова."
        ) {
          setCaptchaUrl("");
          await getDetail();
        }
        if (response.error_type === "other") {
          setCaptchaUrl("");
          await getDetail();
          setErrorMessage(response.errors[0]);
        }
        if (response.errors && response.error_type === "auth") {
          const err = response;
          const errorEvent = new ErrorEvent("error", {
            error: err,
          });
          window.dispatchEvent(errorEvent);
        }
      }

      setIsLoadingBtn(null);

      setIsLoading(false);
    }
  }
  async function handleSupplementaryAgreement(message = "") {
    if (currentNotificationData?.planning_event_id) {
      const data = {
        access_token,
        study_contract_id: contractId,
        planning_event_id: currentNotificationData?.planning_event_id,
        message,
        captcha_data: captchaData,
        captcha_uuid: captchaUuid,
      };
      if (!message || typeof message === "object") {
        delete data.message;
      }
      const request = {
        method: "post",
        path: "/student/portfolio/notification_choice",
        data: data,
      };

      const response = await StudentService.send(request, (response) => {});
      if (!response.errors) {
        setModalMessage("Дополнительное соглашение будет выслано вам на почту");
        setModalMessageOpen(true);
        setModalMessageTitle("Дополнительное соглашение");
      }

      if (response.errors) {
        const err = response;
        const errorEvent = new ErrorEvent("error", {
          error: err,
        });
        window.dispatchEvent(errorEvent);
        // setModalMessage("Произошла ошибка");
      }
      setIsLoadingBtn(null);
    }
  }
  async function getNotificationsSummaries() {
    const request = {
      method: "post",
      path: "/student/portfolio/notifications_summaries",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    };
    try {
      const data = await StudentService.send(request, setNotifiactionsData);
      const lssBlockNotificationsArr = [];
      data.rows.forEach(
        ({ lss_blocking, planning_event_id, is_event_actual }) => {
          if (lss_blocking && !is_event_actual) {
            lssBlockNotificationsArr.push({
              planning_event_id,
              is_event_actual,
              lss_blocking,
            });
          }
        },
      );
      if (lssBlockNotificationsArr.length > 0) {
        dispatch(lssBlockNotificationDataAction(lssBlockNotificationsArr));
      } else {
        dispatch(lssBlockNotificationDataAction(false));
      }
      dispatch(notificationsSummariesAction(data));
    } catch (error) {
      console.log(error);
    }
  }
  const handleSendDiplomAnketaReport = async () => {
    const request = {
      method: "post",
      path: "/student/portfolio/notification_function/send_diplom_anketa_report",
      data: {
        access_token,
        study_contract_id: contractId,
        planning_event_id: currentNotificationData?.planning_event_id,
      },
    };

    const response = await StudentService.send(request);
    if (!response.errors) {
      setModalMessage("Заявление выслано вам на почту");
      setModalMessageTitle("Заявление");
      setModalMessageOpen(true);
    } else {
      const errorEvent = new ErrorEvent("error", {
        error: response,
      });
      window.dispatchEvent(errorEvent);
    }
    setIsLoadingBtn(null);
  };

  useEffect(() => {
    if (
      access_token &&
      contractId &&
      currentNotificationData &&
      currentNotificationData.planning_event_id
    ) {
      getDetail();
    }
  }, [access_token, contractId, currentNotificationData?.planning_event_id]);
  const inputOnChange = (e) => {
    setInputValue(e.target.checked);
    setIsAprooveBtnActive(e.target.checked);
  };

  const renderTextWithComponents = (text) => {
    const parts = text.split("@@AttestationTheme@@");
    return parts.map((part, index) => (
      <div>
        <p dangerouslySetInnerHTML={{ __html: part }}></p>
        {index < parts.length - 1 && <ModalAttestationTheme />}
      </div>
    ));
  };
  const renderButtonWithLoader = (part, index = 0) => {
    if (isLoadingBtn == index) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      );
    } else {
      // Находим все теги a и button с onclick.
      const parser = new DOMParser();
      const doc = parser.parseFromString(part, "text/html");
      const clickableTags = doc.querySelectorAll("a[onclick], button[onclick]");

      clickableTags.forEach((tag) => {
        const originalAttributes = Array.from(tag.attributes)
          .map((attr) => `${attr.name}="${attr.value}"`)
          .join(" ");

        // в onclick, добавляем setBtnIndex чтобы получить индекс нажатой кнопки
        const onclickMatch = originalAttributes.match(/onclick="(.+?)"/);
        if (onclickMatch) {
          const onclickContent = onclickMatch[1];
          const newOnclickValue = `${onclickContent}; setBtnIndex(${index})`;
          const modifiedAttributes = originalAttributes.replace(
            onclickMatch[0],
            `onclick="${newOnclickValue}"`,
          );

          tag.outerHTML = `
            <${tag.tagName.toLowerCase()} ${modifiedAttributes}>
              ${tag.innerHTML}
            </${tag.tagName.toLowerCase()}>`;
        }
      });

      return <div dangerouslySetInnerHTML={{ __html: doc.body.innerHTML }} />;
    }
  };
  const renderTextWithLoaderComponent = (text, anketa_id = null) => {
    // Делаем сплит по @QUESTIONS@<anketa_id>@
    const parts = text.split(new RegExp(`@QUESTIONS@${anketa_id}@`));

    // Парсим HTML
    const result = parts.flatMap((part, index) => {
      const parsedParts = parseHTMLString(part);
      // Вставляем компонент Anket после каждой части, кроме последней
      if (index < parts.length - 1 && anketa_id !== null) {
        parsedParts.push({
          type: "Anket",
          component: (
            <Anket
              handleAgreement={handleAgreementAfterAnket}
              anketa_id={anketa_id}
              getDetail={getDetail}
              planning_event_id={currentNotificationData.planning_event_id}
            />
          ),
        });
      }
      return parsedParts;
    });

    return result.map(({ type, html, component }, index) => {
      if (type === "Anket") {
        return <div key={`anket-${index}`}>{component}</div>;
      }

      return (
        <div key={index}>
          {type !== "other" && renderButtonWithLoader(html, index)}
          {type === "other" && (
            <p dangerouslySetInnerHTML={{ __html: html }}></p>
          )}
        </div>
      );
    });
  };
  function parseHTMLString(htmlString) {
    // Массив, в который будем складывать результат
    const segments = [];
    // Регулярное выражение для поиска тегов <a> и <button> с их содержимым
    const regex = /<(a|button)(\s+[^>]*?)?>([\s\S]*?)<\/\1>/gi;
    let currentIndex = 0;
    let match;

    // Ищем все вхождения тегов <a> и <button>
    while ((match = regex.exec(htmlString)) !== null) {
      // Если между последним найденным тегом и текущим есть "не-теги" - добавляем их как other
      if (match.index > currentIndex) {
        const betweenText = htmlString.slice(currentIndex, match.index);
        segments.push({ type: "other", html: betweenText });
      }
      // Определяем тип тега по первой захваченной группе (a или button)
      const tagType = match[1].toLowerCase();
      const fullMatch = match[0];
      segments.push({ type: tagType, html: fullMatch });
      // Обновляем текущую позицию в строке
      currentIndex = regex.lastIndex;
    }

    // Если после последнего найденного тега остался текст, добавляем его как other
    if (currentIndex < htmlString.length) {
      const remainingText = htmlString.slice(currentIndex);
      segments.push({ type: "other", html: remainingText });
    }

    return segments;
  }

  useEffect(() => {
    if (data?.EventTypeID === 16000) {
      const transformedText = renderTextWithComponents(data.text);
      setData((prev) => {
        return { ...prev, text: transformedText };
      });
      setIsRenderWithComponent(true);
    }
  }, [data?.EventTypeID]);

  useEffect(() => {
    if (data?.EventTypeID === 18680) {
      const replaceATagWithButton = (htmlString) => {
        if (htmlString) {
          const aTagPattern = /<a\b([^>]*)>(.*?)<\/a>/gi;
          const cleanedString = htmlString.replace(
            aTagPattern,
            (match, attributes, innerHTML) => {
              const cleanedAttributes = attributes.replace(/href="[^"]*"/i, "");
              return `<button id="Event18680_agree"${cleanedAttributes}>${innerHTML}</button>`;
            },
          );
          return cleanedString;
        }
      };
      const updatedText = replaceATagWithButton(data.text);
      setData((prev) => ({ ...prev, text: updatedText }));

      const buttons = document.querySelectorAll("#Event18680_agree");

      buttons.forEach((button) => {
        button.addEventListener("click", async (event) => {
          event.preventDefault();
          await window.Notificationchoice("Event18680_agree");
          if (!hasCaptcha) {
            navigate("/learning-plan");
          }
        });
      });
    }
  }, [data?.EventTypeID, data?.text]);
  useEffect(() => {
    if (data?.EventTypeID === 1800) {
      const removeATagWithButton = (htmlString) => {
        if (htmlString) {
          const aTagPattern =
            /<a\s+href="[^"]*"\s+class="[^"]*"\s+onclick='[^']*'\s+target="_blank">(.*?)<\/a>/gi;
          const cleanedString = htmlString.replace(
            aTagPattern,
            (match, innerHTML) => {
              return `<a class="btn disBtn">${innerHTML}</a>`;
            },
          );
          return cleanedString;
        }

        const updatedText = removeATagWithButton(data.text);
        setData((prev) => ({ ...prev, text: updatedText }));
      };
    }
  }, [data?.EventTypeID, data?.is_event_actual, data?.text]);

  useEffect(() => {
    window.Notificationchoice = async (event, ...args) => {
      if (isElectronicAccept !== false) return;
      getDetail();

      if (data?.EventTypeID === 17000) {
        await handleAgreement({ event, args });
        navigate("/payment");
        return;
      }
      const id = `${event}_comment`;
      const textarea = document.getElementById(id);
      let comment = "";
      if (textarea && textarea.style.display !== "none") {
        comment = textarea.value;
        if (!comment || comment.trim().length < 2) {
          const err = {
            error_type: "other",
            errors: ["Необходимо заполнить текстовое поле"],
          };
          const errorEvent = new ErrorEvent("error", {
            error: err,
          });
          window.dispatchEvent(errorEvent);
          //   setEmpyFieldMessage("Необходимо заполнить текстовое поле");
          return;
        }
      }
      if (hasCaptcha) {
        setComment(comment);
        setMessage(event);
        setOpenCaptchaModal(true);
      }
      if (!hasCaptcha) {
        await handleAgreement({ event, comment, args });
        return;
      }
      await handleAgreement({ event, comment, args });
    };
  }, [captchaData, captchaUuid]);
  useEffect(() => {
    window.SetComment = async (event, ...args) => {
      let comment = args[0];
      setCommentFromDB(comment);
    };
  }, [captchaData, captchaUuid]);
  useEffect(() => {
    window.getSupplementaryAgreement = async (event, ...args) => {
      // event = event.toString();
      event = `getSupplementaryAgreement(${event})`;
      await handleSupplementaryAgreement(event);
    };
  }, [captchaData, captchaUuid]);
  useEffect(() => {
    return () => {
      getNotificationsSummaries();
    };
  }, []);

  useEffect(() => {
    window.ChangeCurrentContract = (...args) => {};
    window.setCookie = (...args) => {};
  }, []);
  useEffect(() => {
    window.setBtnIndex = (index) => {
      setIsLoadingBtn(index);
    };
    window.SendDiplomAnketaReport = (...args) => {
      handleSendDiplomAnketaReport();
    };
  }, [data]);
  useEffect(() => {
    // if (firstdata && firstdata.text.match(/@QUESTIONS@\d{1,}@/gm) ) {
    if (firstdata && firstdata.text && firstdata.text.match(/onclick/gm)) {
      const index = firstdata.text.lastIndexOf("@");
      const anketa_id = firstdata.text[index - 1];
      const transformedText = renderTextWithLoaderComponent(
        firstdata.text,
        anketa_id,
      );
      setData((prev) => {
        return { ...prev, text: transformedText };
      });
      setIsRenderWithComponent(true);
    }
  }, [firstdata, isLoadingBtn]);
  const rehypeUniversalOnClick = () => (tree) => {
    const visit = (node) => {
      if (node.properties) {
        // rehypeRaw может распарсить атрибут как onclick или onClick
        const rawOnClick = node.properties.onclick || node.properties.onClick;

        if (rawOnClick) {
          // Сохраняем код в безопасный дата-атрибут data-onclick
          node.properties["data-onclick"] = rawOnClick;
          // Удаляем оригинальные onclick, чтобы React не выдавал ошибку
          delete node.properties.onclick;
          delete node.properties.onClick;
        }
      }
      if (node.children && Array.isArray(node.children)) {
        node.children.forEach(visit);
      }
    };
    visit(tree);
  };
  function UniversalMarkdownRender({ content, className }) {
    const handleContainerClick = (e) => {
      // 1. Обычный путь — элементы с атрибутом onclick
      const dataOnClickTarget = e.target.closest("[data-onclick]");
      if (dataOnClickTarget) {
        const code = dataOnClickTarget.getAttribute("data-onclick");
        if (code) {
          try {
            new Function(code).call(dataOnClickTarget);
          } catch (err) {
            console.error("Ошибка выполнения inline onclick:", err);
          }
        }
        return;
      }
      const legacyTarget = e.target.closest(".notificationchoice");
      if (legacyTarget && legacyTarget.id) {
        e.preventDefault();
        window.Notificationchoice(legacyTarget.id);
      }
    };

    return (
      <div className={className} onClick={handleContainerClick}>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw, rehypeUniversalOnClick]}
        >
          {content}
        </ReactMarkdown>
      </div>
    );
  }
  if (!firstdata && !data)
    return (
      <Dialog
        open={true}
        aria-labelledby="responsive-dialog-title"
        classes={{ paper: cls.dialog_paper }}
        disableEscapeKeyDown
        hideBackdrop
        // style={{ backgroundColor: "rgba(155,155,155,.63)" }}
      >
        <LinearLoader />
      </Dialog>
    );
  if (data)
    return (
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        classes={{ paper: cls.dialog_paper }}
        disableEscapeKeyDown
        hideBackdrop
        // style={{ backgroundColor: "rgba(155,155,155,.63)" }}
      >
        <DialogTitle
          sx={{ margin: "0", padding: "0" }}
          id="responsive-dialog-title"
        >
          <div> {new Date(data.sys_creation_date).toLocaleDateString()}</div>
        </DialogTitle>
        <DialogTitle
          sx={{ margin: "0 0 1.875rem 0 !important", padding: "0" }}
          id="responsive-dialog-title"
        >
          {data.header}
        </DialogTitle>
        <DialogContent sx={{ margin: "0", padding: "0" }}>
          {/* <DialogContentText classes={{ paper: cls.dialog_title }}> */}
          {isRenderWithComponent ? (
            <div className={cls.contentText}>
              {isElectronicAccept ? data.agreement_text : data.text}
            </div>
          ) : (
            // <p
            //   className={cls.contentText}
            //   dangerouslySetInnerHTML={{
            //     __html: isElectronicAccept ? data.agreement_text : data.text,
            //   }}
            // ></p>
            <UniversalMarkdownRender
              className={cls.contentText}
              content={isElectronicAccept ? data?.agreement_text : data?.text}
            />
          )}

          {/* </DialogContentText> */}
        </DialogContent>
        <div className={cls.dialogActions}>
          <div className={cls.notificationCheckbox}>
            {isShowControlBtn && (
              <>
                <input
                  checked={inputValue}
                  onChange={inputOnChange}
                  type="checkbox"
                  className={cls.input}
                  disabled={currentNotificationData?.is_event_actual}
                />
                <p className={cls.agreement}>Прочитано, выражаю согласие</p>
              </>
            )}
          </div>

          {/* <div> */}
          <DialogActions classes={{ paper: cls.dialogContnent }}>
            {isShowControlBtn && (
              <Button onClick={handleAgreement} disabled={!isAprooveBtnActive}>
                Подтвердить
              </Button>
            )}
            <Button
              type="primary"
              disabled={
                data.is_event_actual === false && data.LSSBlocking === true
              }
              onClick={handleClose}
            >
              Закрыть
            </Button>
          </DialogActions>
          {/* </div> */}
        </div>
        {modalMessageOpen && (
          <ModalMessage
            title={modalMessageTitle}
            message={modalMessage}
            open={modalMessageOpen}
            setOpen={setModalMessageOpen}
            onClose={handleClose}
          />
        )}

        <ModalCaptcha
          open={openCaptchaModal}
          setOpen={setOpenCaptchaModal}
          captchaUrl={captchaUrl}
          captchaData={captchaData}
          setCaptchaData={setCaptchaData}
          handleAgreementWithCaptcha={handleAgreementWithCaptcha}
          comment={comment || commentFromDB || ""}
          message={message}
          errorMessage={errorMessage}
          isLoading={isLoading}
        />
      </Dialog>
    );
}
